document.addEventListener('DOMContentLoaded', () => {
  /**
   * ✅ Map the Decision Making tile label -> product handle for Quick View
   * IMPORTANT: Keep these keys exactly how they appear on the tiles.
   */
  const TILE_TO_PRODUCT_HANDLE = {
    'i am new': 'rally-metric-origin-rm-gf',

    // OPTIONAL (only add these once you confirm the real handles)
    // 'i play every week': 'rally-metric-core-t300',
    // 'i want more control': 'rally-metric-signature',
    // 'i want more power': 'rally-metric-velocity',
  };

  // 1) Find the section that contains the heading "Which best describes you?"
  const decisionSection = findSectionByText('which best describes you?');
  if (!decisionSection) return;

  // 2) Intercept clicks inside that section (works even if user clicks the image, text, etc.)
  decisionSection.addEventListener('click', (e) => {
    const link = e.target.closest('a');
    if (!link) return;

    // allow open-in-new-tab etc
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    // Read the tile title (the visible label like "I am new")
    const label = getTileLabel(link);
    const key = normalize(label);

    const productHandle = TILE_TO_PRODUCT_HANDLE[key];
    if (!productHandle) return; // not one of our tiles → do nothing

    // Stop the collection page navigation
    e.preventDefault();

    // Open Quick View for that product
    openQuickView(productHandle);
  });

  function openQuickView(handle) {
    // Best case: find quick view button by product handle
    let btn =
      document.querySelector(`[is="quick-view-button"][data-product-handle="${handle}"]`) ||
      document.querySelector(`button[is="quick-view-button"][data-product-handle="${handle}"]`);

    if (btn) {
      btn.click();
      return;
    }

    // Fallback: find the product link on the page (from Pick Your Paddle grid)
    const productLink =
      document.querySelector(`a[href*="/products/${handle}"]`) ||
      document.querySelector(`a[href="/products/${handle}"]`);

    if (!productLink) {
      // Last fallback: go to product page (not ideal, but prevents "nothing happens")
      window.location.href = `/products/${handle}`;
      return;
    }

    const card =
      productLink.closest('.card') ||
      productLink.closest('[class*="card"]') ||
      productLink.closest('li') ||
      productLink.closest('div');

    if (!card) {
      window.location.href = `/products/${handle}`;
      return;
    }

    btn =
      card.querySelector('[is="quick-view-button"]') ||
      card.querySelector('button[is="quick-view-button"]') ||
      card.querySelector('[data-quick-view]') ||
      card.querySelector('button[data-quick-view]') ||
      card.querySelector('button[aria-haspopup="dialog"]');

    if (!btn) {
      window.location.href = `/products/${handle}`;
      return;
    }

    btn.click();
  }

  function findSectionByText(textLower) {
    const sections = Array.from(document.querySelectorAll('[id^="shopify-section-"]'));
    return sections.find((sec) => (sec.textContent || '').toLowerCase().includes(textLower)) || null;
  }

  function getTileLabel(linkEl) {
    // Try the most common title elements first
    const t =
      linkEl.querySelector('h1,h2,h3,h4,h5,h6,.card__title,.card__heading,.collection-card__title')?.textContent;

    return (t || linkEl.textContent || '').trim();
  }

  function normalize(str) {
    return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
});
